import React from 'react';
import { Dropdown } from 'primereact/dropdown';

/*
    filter - FilterElement,
    options - [{label, value}, ...],
    name - ""
*/
export const DropdownFilterTemplate = (filter, options, name) => {
	let opts = options.filter(val => val !== null);

	return (
		<Dropdown value={filter.value}
			options={opts}
			onChange={(e) => filter.filterApplyCallback(e.value)}
			placeholder={name}
			className="p-column-filter"
		/>
	);
}